import "./fetch";
import React from "react";
import { createRoot } from "react-dom/client";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.min.css";
import "assets/styles/override.css";
import "styles/style.css";
import "styles/live-kit.css";
import "styles/themes.css";
import "sweetalert2/dist/sweetalert2.min.css";

import App from "App";

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(<App />);
